var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BuyBase",
    {
      staticClass: "tap-advance",
      attrs: {
        title: _vm.getConstants("PRICING_NEW_COMMON_ADVANCE"),
        actions: _vm.getConstants("PRICING_NEW_TAP_CHECK_DETAIL"),
        type: "advance"
      },
      on: { viewDetail: _vm.viewDetail }
    },
    [
      _c(
        "div",
        { attrs: { slot: "limit" }, slot: "limit" },
        [
          _c("p", [_vm._v(_vm._s(_vm.space))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.add))]),
          _vm._v(" "),
          _c("UploadTip"),
          _vm._v(" "),
          _vm.upgradeVisible
            ? _c("UpgradeTip", {
                staticClass: "upgrade-tip-advance",
                on: {
                  close: function($event) {
                    _vm.upgradeShowed = true
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }